module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }